<template>
  <gg-modal :is-active="isActive" width="640" @close="close">
    <template v-slot:toolbar>
      Settings — {{ mailbox.email }}
    </template>
    <template v-slot:body>
      <!-- Rendered only while open so each opening re-reads plus addressing. -->
      <mailbox-security-view
        v-if="isActive"
        embedded
        class="pt-2"
        :mailbox="mailbox"
        @changed="$emit('changed')"
      />
    </template>
    <template v-slot:actions>
      <v-spacer></v-spacer>
      <gg-btn secondary @click="close">Close</gg-btn>
    </template>
  </gg-modal>
</template>

<script>
import MailboxSecurityView from '@/views/email/mailbox/MailboxSecurityView'

/**
 * The mailbox's restrictions (receive, send, log in) and plus addressing, from
 * the row menu (AM-1106). Each control saves on change, so there is no Save
 * button — the same panel as the Security tab, in a modal.
 */
export default {
  name: 'MailboxSettingsModal',
  components: { MailboxSecurityView },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    mailbox: {
      type: Object,
      required: true,
    },
  },
  methods: {
    close () {
      this.$emit('close')
    },
  },
}
</script>
